module.exports = __webpack_public_path__ + "media/images/application/template/logos/barnsley-fc-e3228e385ff090fa06add1513d422a6e.png";